import React, { useEffect, useState, useContext } from 'react'
import './train.css';
import { 
  Radio,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Box,
  Container,
  Typography,
  Button,
  Menu,
  MenuItem
} from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useUserAuth } from '../login/userAuthContext';
import { useNavigate } from 'react-router';
import TrainMenu from '../dropdowns/dropTrainStation';
import { NavigatorContext } from '../../contexts/NavigatorContext';



const months = ["Jan'", "Feb'", "Mar'", "April", "May", "June", "July", "Aug'", "Sept'", "Oct'", "Nov'", "Dec'"];
const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]


const saerchBtnStyle = {
  position: 'sticky',
  left: '40%',
  top:'65%',
  fontSize: '30px',
  borderRadius: '30px',
  width: '300px',
  marginTop:'70px'
}

export default function Trains() {
  const [value, setValue] = useState('one');
  const {user} = useUserAuth();
  const navigate = useNavigate();
  const [start, setStart] = useState({
    City: "New Delhi",
    station: "NDLS New Delhi Railway Station"
  });
  const [dest, setDest] = useState({
    City: "Mumbai",
    station: "MMCT Mumbai Railway Station"
  });
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const {setParam} = useContext(NavigatorContext);
  useEffect(()=>{
    setParam('train');
  }, [])
  const [cityClicked1, setCityClicked1] = useState(false);
  const [cityClicked2, setCityClicked2] = useState(false);
  const [date,setDate] = useState();
  const [userDate, setUserDate] = useState(new Date());
  useEffect(()=>{
    setUserDate(new Date(date));
  }, [date])
  function CityCrad(props){
    const handleCityClick = ()=> {
      if(props.initial==='From'){
        setCityClicked1(true);
      }else if(props.initial==='To'){
        setCityClicked2(true);
      }
    }
    return <div className='cityCardTrain' onMouseOver={handleCityClick}>
      <Typography variant='body2' fontSize='14px' paddingBottom='20px'>{props.initial}</Typography>
      <Typography variant='h1' fontSize='30px' fontWeight='bolder'>{props.cityName}</Typography>
      <Typography variant='body2' fontSize='10px'>{props.airport}</Typography>
    </div>
  }
  function DateCard(props){
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleDates = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (e)=>{
    e.persist();
    setAnchorEl(null);
  }
  const handleDateSetting = (e)=>{
    e.persist();
    if(props.showDate){
      setDate(e.target.value);
    }else{
      return;
    }
    
  }
  useEffect(()=>{
    setAnchorEl(null);
  }, [date])
    return <div className='dateCardTrain'>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleDates}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{textTransform:'none'}}
      >
        {props.option}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem><input type='date' onChange={handleDateSetting}/></MenuItem>
      </Menu>
      {props.showDate && 
        <div>
        {date ? <>
          <Box display='flex'>
          <Typography variant='h1' fontSize='40px'>{userDate.getDate()}</Typography>
          <Typography variant='h3' fontSize='23px'>{months[userDate.getMonth()]}</Typography>
          <Typography variant='h3' fontSize='23px'>{userDate.getFullYear()}</Typography>
          </Box>
          <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[userDate.getDay()]}</Typography>
        </> : 
        <>
          <Box display='flex'>
          <Typography variant='h1' fontSize='40px'>{new Date().getDate()}</Typography>
          <Typography variant='h3' fontSize='23px'>{months[new Date().getMonth()]}</Typography>
          <Typography variant='h3' fontSize='23px'>{new Date().getFullYear()}</Typography>
          </Box>
          <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[new Date().getDay()]}</Typography>
        </>
        }
      </div>
      }
      {!props.showDate && <Typography variant='body2' fontWeight='bold' textAlign='left' sx={{padding:'10px'}}>Tap to add a return date for bigger discount</Typography>}
    </div>
  }

  const [classSelected, setClass] = useState("ALL");
  function Traveller(){
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
      setAnchorEl(null);
    }
    const handleClass = (e)=>{
      setClass(e.target.id);
    }
    return <div className='travellerTrain'>
       <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleOpen}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{textTransform:'none'}}
      >
        Class
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem id='AC First Class' onClick={handleClass}>AC FirstClass</MenuItem>
        <MenuItem id='AC Second Class' onClick={handleClass}>AC SecondClass</MenuItem>
        <MenuItem id='AC Three Class' onClick={handleClass}>AC Three Class</MenuItem>
        <MenuItem id='Sleeper' onClick={handleClass}>Sleeper Class</MenuItem>
      </Menu>
      <h4><span style={{fontSize:'30px', lineHeight:'0'}}>{classSelected}</span></h4>
      <Typography variant='body2' fontWeight='500'>All class</Typography>

    </div>
  }
  const handleTickets = ()=> {
    if(user){
      navigate('/tickets/train');
    }else{
      navigate('/login');
    }
  }
  return (
    <div>
      <div className='train-card'>
      <Container>
        <FormControl component="fieldset">
          <FormLabel component="legend"> </FormLabel>
          <RadioGroup name="tour" value={value} onChange={handleChange}>
          <Box
          display='flex'
          sx={{paddingTop: '40px'}}
          >
            <FormControlLabel value="one" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label="Book Train Tickets" />
            <FormControlLabel value="round" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label="Check PNR status" />
            <FormControlLabel value="multi" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label="Live Train Status" />
          </Box>
          </RadioGroup>
        </FormControl>
      </Container>
      <div className='sliderTrain'>
        <Box display='flex'>
          <CityCrad initial={'From'} cityName={start.City} airport={start.station} />
          <CityCrad initial={'To'} cityName={dest.City} airport={dest.station} />
          <DateCard option={'Departure'} showDate={true}/>
          <Traveller />
        </Box>
      </div>
      <Button variant='contained' sx={saerchBtnStyle} onClick={handleTickets}>SEARCH</Button>
    </div>
    {cityClicked1 && <div className='railPos1'><TrainMenu setterFunc={setStart} removeMenu={setCityClicked1}/></div> }
    {cityClicked2 && <div className='railPos2'><TrainMenu setterFunc={setDest} removeMenu={setCityClicked2}/></div> }
    </div>
  )
}
